import { Notification } from 'core/layouts/main/models/notificationModel';

// maps a notification's link data to the dashboard page it refers to
export const getNotificationLink = ({ link_data }: Notification): string | null => {
	if (!link_data) return null;

	const { type, id } = link_data;

	switch (type) {
		case 'assembly':
			return `/dashboard/actions/assemblies/view/${id}`;
		case 'board':
			return '/dashboard/actions/boards';
		case 'board_meeting':
			return `/dashboard/actions/boards/meetings/view/${id}`;
		case 'committee':
			return '/dashboard/actions/boards/committees';
		case 'committee_meeting':
			// committee meeting view needs the committee id, which link data doesn't include
			return '/dashboard/actions/boards/committees/meetings';
		case 'registry_transaction':
			return `/dashboard/actions/registry-transactions/${id}`;
		case 'heirloom_transaction':
			return `/dashboard/actions/heirs-transfer/${id}`;
		case 'suspend_action':
			return `/dashboard/actions/suspend/company/${id}`;
		case 'system_suspend_action':
			return `/dashboard/actions/suspend/system/${id}`;
		case 'raise_capital_action':
			return `/dashboard/actions/capitals/view/${id}`;
		case 'dividends_action':
			return `/dashboard/actions/dividends/view/${id}`;
		case 'notice_action':
			return `/dashboard/actions/notice/${id}`;
		case 'announcement_action':
			return `/dashboard/actions/announcement/${id}`;
		case 'update_document_action':
			return `/dashboard/actions/update-documents/${id}`;
		case 'financial_statement_action':
			return `/dashboard/actions/financial-statement/${id}`;
		case 'payment':
			return '/dashboard/company-information/payments';
		default:
			return null;
	}
};
